import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "Introduction",
    paragraphs: [
      "This policy addresses the compliance framework envisaged by the Reserve Bank of India through Notification DNBS (PD) C.C. No. 133/03.10.001/2008-09 dated January 2, 2009 in respect of regulation of excessive interest charged by NBFCs.",
      "The above framework has now been replaced by the Master Direction - Non-Banking Financial Company - Non-Systemically Important Non-Deposit taking Company (Reserve Bank) Directions, 2016 dated September 1, 2016.",
      "Finncube Credit Services Pvt. Ltd. (the Company) is engaged in the business of providing financing products to its customers, including individuals, partnership firms, companies, and other organisations.",
      "The Company has framed and adopted a voluntary policy that sets out an interest rate model taking into account relevant factors such as cost of funds, margin, risk premium, and gradation of risks in order to determine the rate of interest to be charged on loans and advances.",
    ],
  },
  {
    heading: "Objective",
    paragraphs: [
      "The objective of this policy is to ensure that interest rates charged to customers do not exceed a reasonable level and remain aligned with normal financial practice.",
      "This policy is also formulated to ensure transparency and conformity with the directives issued by the Reserve Bank of India (RBI).",
    ],
  },
  {
    heading: "Company Policy",
    paragraphs: [
      "The following aspects are considered and followed by the NBFC for meticulous compliance with the regulatory circular and related requirements.",
    ],
    items: [
      'The NBFC shall not charge "excessive" interest rates.',
      "The rate of interest will be duly disclosed to borrowers in the welcome kit and in the copy of the agreement provided to them.",
      "The interest rate shall be decided by the committee authorised by the Board of Directors or by the Board of Directors themselves.",
      "The principles and procedures for determining interest rate, processing charges, and other charges shall be based on approved internal practices.",
    ],
  },
  {
    heading: "Factors Considered for Determining Interest Rates",
    paragraphs: [
      "The interest rates will be determined by the NBFC based on the following relevant factors:",
    ],
    items: [
      "Cost of funds to the Company.",
      "Risk profile of the borrower.",
      "Interest rate prevailing in the industry.",
      "Margin and risk premium charged for different categories of loans.",
      "Securities offered and the type of risks attached thereto.",
      "Duration of the loan repayment schedule.",
      "Category of the borrower.",
      "Earning source of the borrower.",
      "Nature of income and the regularity of income of the borrower.",
      "The approach for gradation of risks will be documented.",
    ],
  },
  {
    heading: "Information to Customers",
    items: [
      "Interest is to be calculated on the amount utilised by the borrower and not merely on the sanctioned limit.",
      "No interest is payable on any credit balance in the borrower's account.",
      "The rationale for charging different rates of interest to different categories of borrowers shall be documented and disclosed in the application form and communicated explicitly through the welcome letter or sanction letter.",
      "The rates of interest and the approach for gradation of risks shall be made available on the website.",
      "Whenever there is any change in the rate of interest or any important change in the policy, the same shall be informed through email to existing clients and the revised version shall be made available on the website of the Company.",
      "The rate disseminated shall also mention the annualised rate so that the borrower is aware of the exact rates charged to the account.",
      "Accrual of interest shall be on a daily basis and shall be charged on a monthly or quarterly basis, as applicable, on the last day of the respective month or quarter.",
      "The Company shall disclose in bold letters in the loan agreement any clause pertaining to penal interest charged, if any, for late repayment.",
      "Interest shall be deemed payable immediately. However, a grace period may be allowed for payment of interest.",
      "Any change in rates or other charges shall have prospective effect and shall be communicated to customers on their registered email ID.",
    ],
  },
  {
    heading: "Amendments",
    paragraphs: [
      "This policy and any of its clauses shall be suitably modified based on directions issued by the Reserve Bank of India from time to time.",
      "Any such changes or amendments shall be placed before the Board of Directors in the meeting immediately succeeding such change or amendment.",
    ],
  },
];

function InterestRatePolicy() {
  return (
    <PolicyLayout
      title="Interest Rate Charges Policy"
      intro="This policy explains the framework followed by Finncube Credit Services Pvt. Ltd. for determining, disclosing, and applying interest rates in a fair, transparent, and RBI-aligned manner."
      lastUpdated="April 10, 2026"
      sections={sections}
    />
  );
}

export default InterestRatePolicy;
